import { client } from 'lib/evi-api-gateway';

import { searchParams } from 'types/course';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api/course`;

// 获取分类标签
export async function getTag() {
  return client.post({
    url: `${url}/get_tag`,
    form: {}
  });
}

// 搜索课件
export async function searchCourse(params: searchParams) {
  return client.post({
    url: `${url}/search`,
    form: {
      params
    }
  });
}
//新增课程
export async function courseAdd(form: any, item: any) {
  return client.post({
    url: `${url}/add`,
    form: {
      ...form,
      item
    }
  });
}

//編輯課程
export async function courseUpdate(form: any, item: any) {
  return client.post({
    url: `${url}/update`,
    form: {
      ...form,
      item
    }
  });
}
// 获取课程信息
export async function getInfo(urlId: string) {
  return client.post({
    url: `${url}/get`,
    form: {
      id: urlId
    }
  });
}
export async function getFullInfo(i_courseID = null) {
  return client
    .post({
      url: `${url}/get_full_info`,
      form: {
        id: i_courseID
      }
    })
    .then((_ret: any) => {
      _ret.grade = _ret.grade.map((_grade: any) => {
        let __grade = _grade.split('-');
        return `${__grade[1]}-${__grade[0]}` + (__grade.length > 2 ? `-${__grade[2]}` : '');
      });
      return _ret;
    });
}
// 新增时生成临时课程活动
export async function addCourseTemp() {
  return client.post({
    url: `${url}/add_temp`,
    form: {}
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTag,
  searchCourse,
  courseAdd,
  courseUpdate,
  getInfo,
  getFullInfo,
  addCourseTemp
};
